import React, { useEffect, useState } from "react";
import "./Markers.scss";
import { getTextPosition } from "./markerUtils";

export default function MarkerText({
    name,
    coords,
    align = "right",
    pinSize,
    marginToNextLine = 48,
    offsets,
    className = "marker-text",
    zoom = 1,
    zoomThreshold = 1.5,
}) {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        // Hide text when zoom is greater than the threshold
        setVisible(zoom <= zoomThreshold);
    }, [zoom, zoomThreshold]);
    const nameFormatted = name.toUpperCase();
    const nameLines = nameFormatted.split("\n");

    const { textX, textY, textAnchor, textDominantBaseline } = getTextPosition(
        align,
        coords,
        pinSize,
        nameLines.length,
        marginToNextLine,
        offsets
    );

    return (
        <g
            className={`${className} ${
                visible ? "marker-text-visible" : "marker-text-hidden"
            }`}
        >
            {nameLines.map((line, index) => (
                <text
                    key={index}
                    x={textX}
                    y={textY + marginToNextLine * index}
                    textAnchor={textAnchor}
                    dominantBaseline={textDominantBaseline}
                    className="marker-text-line"
                >
                    {line}
                </text>
            ))}
        </g>
    );
}
